import { router } from "@inertiajs/react";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "@/components/ui/Select";
import { wholesale_forecast_by_account_path } from "@/lib/routes";

export interface ChannelOption {
  id: string;
  name: string;
}

interface Props {
  marketSlug: string;
  channels: ChannelOption[];
  selectedChannelId: string | null;
}

// Channel switcher, shown only when the market has more than one
// manual-planning channel (the caller gates on channels.length > 1). Navigates
// with ?channel_id= to switch which channel the grid reads. Callers making
// writes (cell save, import) must also send channel_id explicitly — the
// server falls back to the market's first manual channel when it's absent,
// which silently misfiles writes made while viewing a non-default channel.
export default function ChannelSelect({ marketSlug, channels, selectedChannelId }: Props) {
  return (
    <Select
      value={selectedChannelId ?? undefined}
      onValueChange={(channelId) =>
        router.get(
          wholesale_forecast_by_account_path(marketSlug),
          { channel_id: channelId },
          { preserveState: true },
        )
      }
    >
      <SelectTrigger className="h-auto w-auto gap-2 px-3 py-1.5 text-xs font-semibold">
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="start">
        {channels.map((channel) => (
          <SelectItem key={channel.id} value={channel.id}>
            {channel.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
